import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
// 组件导入
// import noticeList from '../src/components/more/noticeList.vue'
const noticeList = () => import('../src/components/more/noticeList.vue')
// import newsList from '../src/components/more/newsList.vue'
const newsList = () => import('../src/components/more/newsList.vue')
// import selfConstruction from '../src/components/more/selfConstruction.vue'
const selfConstruction = () => import('../src/components/more/selfConstruction.vue')
// import selfConstructionList from '../src/components/more/selfConstructionList.vue'
const selfConstructionList = () => import('../src/components/more/selfConstructionList.vue')
// import newsDetail from '../src/components/more/newsDetail.vue'
const newsDetail = () => import('../src/components/more/newsDetail.vue')
// import newsSecondDetail from '../src/components/more/newsSecondDetail.vue'
const newsSecondDetail = () => import('../src/components/more/newsSecondDetail.vue')
// import noticeDetail from '../src/components/more/noticeDetail.vue'
const noticeDetail = () => import('../src/components/more/noticeDetail.vue')
// import picList from '../src/components/more/picList.vue'
const picList = () => import('../src/components/more/picList.vue')
// import webMap from '../src/components/foot/webMap.vue'
const webMap = () => import('../src/components/foot/webMap.vue')
// import AboutUs from '../src/components/foot/AboutUs.vue'
const AboutUs = () => import('../src/components/foot/AboutUs.vue')
// import Mzsm from '../src/components/foot/Mzsm.vue'
const Mzsm = () => import('../src/components/foot/Mzsm.vue')
// import introduce from '../src/components/more/introduce.vue'
const introduce = () => import('../src/components/more/introduce.vue')
// import Yzjy from '../src/components/foot/Yzjy.vue'
const Yzjy = () => import('../src/components/foot/Yzjy.vue')
// import Sytg from '../src/components/foot/Sytg.vue'
const Sytg = () => import('../src/components/foot/Sytg.vue')
// import Snjd from '../src/components/foot/Snjd.vue'
const Snjd = () => import('../src/components/foot/Snjd.vue')
// import Email from '../src/components/foot/Email.vue'
const Email = () => import('../src/components/foot/Email.vue')
// import SSWJJ from '../src/components/foot/SSWJJ.vue'
const SSWJJ = () => import('../src/components/foot/SSWJJ.vue')
import XSJJ from '../src/components/foot/XSJJ.vue'
// const XSJJ = () => import('../src/components/foot/XSJJ.vue')

// 导入路由加载的进度条动画包 nprogress
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'



Vue.use(Router);
NProgress.inc(0.2);
NProgress.configure({
  easing: 'ease',
  speed: 1000,
  showSpinner: false,
  trickle: false
})

// 路由表
const routes = [{
    path: '/noticeList',
    component: noticeList
  },
  {
    path: '/',
    component: Home
  },
  {
    path: '/newsList',
    component: newsList,
    name: 'routeNewsList'
  },
  {
    path: '/selfConstruction',
    component: selfConstruction,
    name: 'selfConstruction'
  },
  {
    path: '/selfConstructionList',
    component: selfConstructionList,
    name: 'selfConstructionList'
  },
  {
    path: '/newsDetail',
    component: newsDetail,
    name: 'routeNewsDetail'
  },
  {
    path: '/newsSecondDetail',
    component: newsSecondDetail,
    name: 'routeSecond'
  },
  {
    path: '/noticeDetail',
    component: noticeDetail,
    name: 'routeNoticeDetail'
  },
  {
    path: '/picList',
    component: picList,
    name: 'routePicList'
  },
  {
    path: '/webMap',
    component: webMap,
    name: 'routeWebMap'
  },
  {
    path: '/AboutUs',
    component: AboutUs,
    name: 'routeAboutUs'
  },
  {
    path: '/Mzsm',
    component: Mzsm,
    name: 'routeMzsm'
  },
  {
    path: '/introduce',
    component: introduce,
    name: 'routeIntroduce'
  },
  {
    path: '/Yzjy',
    component: Yzjy,
    name: 'routeYzjy'
  },
  {
    path: '/Sytg',
    component: Sytg,
    name: 'routeSytg'
  },
  {
    path: '/Snjd',
    component: Snjd,
    name: 'routeSnjd'
  },
  {
    path: '/Email',
    component: Email,
    name: 'routeEmail'
  },
  {
    path: '/SSWJJ',
    component: SSWJJ,
    name: 'routeSSWJJ'
  },
  {
    path: '/XSJJ',
    component: XSJJ,
    name: 'routeXSJJ'
  },
];

const router = new Router({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
});

router.beforeEach((to, from, next) => {
  NProgress.start();
  next()
})

router.afterEach((to, from) => {
  // console.log('router.afterEachrouter.afterEach',to,from);
  NProgress.done();
  // document.querySelector("body").setAttribute("style", "overflow: auto !important;")
  // window.scrollTo(0,0)
})

// 解决点击重复路由出现的报错
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router;